module.exports = __webpack_public_path__ + "media/images/favicon-8442aacee9a0b3c0cec9a2dd3f48ebc1.ico";